import type { Action } from '@reduxjs/toolkit';

// ---

export const OPEN_LOGIN_DIALOG = 'SIGNING_DIALOG:OPEN_LOGIN';

export type OpenLoginDialog = Action<typeof OPEN_LOGIN_DIALOG>;

export const openLoginDialog = (): OpenLoginDialog => ({
  type: OPEN_LOGIN_DIALOG,
});

// ---

export const OPEN_REGISTRATION_DIALOG = 'SIGNING_DIALOG:OPEN_REGISTRATION';

export type OpenRegistrationDialog = Action<typeof OPEN_REGISTRATION_DIALOG>;

export const openRegistrationDialog = (): OpenRegistrationDialog => ({
  type: OPEN_REGISTRATION_DIALOG,
});

// ---

export const CLOSE_SIGNING_DIALOG = 'SIGNING_DIALOG:CLOSE';

export type CloseSigningDialog = Action<typeof CLOSE_SIGNING_DIALOG>;

export const closeSigningDialog = (): CloseSigningDialog => ({
  type: CLOSE_SIGNING_DIALOG,
});
